// components/Footer.js
import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <p>
                &copy; 2024 Antiquaire Expert Paris. Made by{' '}
                <a href="https://antoineperry.fr">Antoine PERRY</a>
                | Mentions légales | Plan du site | Politique de confidentialité
            </p>
        </footer>
    );
}

export default Footer;
